import { render, staticRenderFns } from "./DashAppointments.vue?vue&type=template&id=f6af8276"
import script from "./DashAppointments.vue?vue&type=script&lang=js"
export * from "./DashAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports